var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeaponsSidearms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.748 473.09a20.53 20.53 0 1 0 0-29 20.46 20.46 0 0 0 0 29zm89.32-218a8.51 8.51 0 1 1 12 12 38.43 38.43 0 0 0 0 54.36l50.6 50.52a38.47 38.47 0 0 0 54.4 0 8.54 8.54 0 0 1 12-.06 8.42 8.42 0 0 1 0 12 55 55 0 0 1-39.22 16.06 54.94 54.94 0 0 1-39.22-16.08l-50.56-50.37a55.46 55.46 0 0 1 0-78.43zm314.86-196.81c8.78-8.31 36.35-25.4 36.35-25.4s-17.08 27.56-25.4 36.35c-58.39 61.66-215.17 222.6-267.3 276.06l-19.71-19.71c53.46-52.13 214.4-208.91 276.06-267.3zm-336.79 325.53c8.8-8.8 17.5-16.88 25.68-23.94l20.47 20.47c-7.07 8.19-15.14 16.88-23.94 25.68a423.48 423.48 0 0 1-41.95 37.16 36.77 36.77 0 0 0-17.33-17.54 424 424 0 0 1 37.07-41.83z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeaponsSidearms);
export default __webpack_public_path__ + "static/media/weapons-sidearms.1de8672b37a4ca1c826888f6f5adb413.svg";
export { ForwardRef as ReactComponent };